import { NavLink } from "react-router-dom";
import type { ScreenDefinition } from "@/domain/screen";

export function SubTabBar({ screens }: { screens: ScreenDefinition[] }) {
  const hasSubTabs = screens.length > 1 || screens[0]?.subTab;
  if (!hasSubTabs) return null;

  return (
    <nav className="sub-tab-bar">
      {screens.map((s) => (
        <NavLink
          key={s.route}
          to={s.route}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          {s.subTab ?? s.mainTab}
        </NavLink>
      ))}
    </nav>
  );
}
